import React, { useState } from 'react';
import { StarsContainer, Star, ContainerInsideStar, InsideStar } from './styles';

const StarsRating = ({
  widthContainer,
  width,
  height,
  icon,
  filledColor,
  emptyColor,
  value,
  numOfStars,
  dataPanel
}) => {
  const [showInsideStar, setShowInsideStar] = useState(false);
  const arrayNumbersOfStars = () => {
    const inicialArray = [];
    for (let i = 1; i <= numOfStars; i += 1) {
      inicialArray.push(i);
    }
    return inicialArray;
  };

  const calculateRate = (valueRate, numStars) => {
    if (!valueRate) return '0';
    const valueFloat = parseFloat(valueRate).toFixed(2);
    if (valueFloat >= numStars) {
      return '100';
    }
    if (valueFloat > numStars - 1 && valueFloat < numStars) {
      const arrayValue = valueFloat.toString().split('.');
      if (arrayValue[1] && arrayValue[1].length > 2) return '100';
      // Se añade un '0' en caso de que el valor del servicio venga con un sólo dígito decimal:
      const percentage = arrayValue[1] && arrayValue[1].length === 1 ? arrayValue[1].padEnd(2, '0') : arrayValue[1];
      return percentage;
    }
    return '0';
  };

  const setShowStars = () => {
    setShowInsideStar(!showInsideStar);
  };

  return (
    <StarsContainer width={widthContainer} data-panel={dataPanel}>
      {arrayNumbersOfStars().map(num => {
        return (
          <ContainerInsideStar
            key={num}
            width={width}
            height={height}
            color={emptyColor}
            showInsideStar={showInsideStar}
          >
            <Star
              width={width}
              height={height}
              icon={icon}
              src={icon}
              alt={`rating-star-${num}`}
              dataPanel={`rating-star-${num}`}
              onLoad={setShowStars}
            />
            {showInsideStar && <InsideStar height={height} fill={calculateRate(value, num)} color={filledColor} />}
          </ContainerInsideStar>
        );
      })}
    </StarsContainer>
  );
};

export default StarsRating;
